import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M14 10a3.987 3.987 0 0 0-1.172-2.828l1.415-1.415A6 6 0 1 1 9 4.083V2.062A8.001 8.001 0 0 0 10 18a8 8 0 0 0 5.657-13.657L17.07 2.93A9.969 9.969 0 0 1 20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0c.338 0 .671.017 1 .05v8.218a2 2 0 1 1-2 0V6.126A4.002 4.002 0 0 0 10 14a4 4 0 0 0 4-4z"
});

var SvgStoreStatusMajor = function SvgStoreStatusMajor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgStoreStatusMajor as S };
